import { createSelector } from '@reduxjs/toolkit';
import { findFirst } from "../../_shared/utils/arrays";
import { PAYMENT_METHODS_SLUGS, USER_TYPE } from "../../constants/const";
import { FTTB_TAB, MOBILE_TAB } from "../../constants/interactive";
import { EPaymentConstant } from "./constants";
var getCommon = function getCommon(state) {
  var _state$common;
  return (_state$common = state.common) !== null && _state$common !== void 0 ? _state$common : {};
};
export var getInlineLayoutFlag = function getInlineLayoutFlag(state) {
  return getCommon(state).inlineLayout;
};
export var getBankList = function getBankList(state) {
  return getCommon(state).bankList;
};
export var getPaymentSum = function getPaymentSum(state) {
  var _getCommon$paymentDat, _findFirst;
  var safeFraction = (_getCommon$paymentDat = getCommon(state).paymentData.sum) === null || _getCommon$paymentDat === void 0 ? void 0 : _getCommon$paymentDat.replace(/,/g, '.');
  var _sum = Number(safeFraction);
  var sum = (_findFirst = findFirst([!Number.isNaN(_sum) && _sum])) !== null && _findFirst !== void 0 ? _findFirst : 0;
  return "".concat(sum.toFixed(2));
};
export var getPaymentSumInKopeikas = function getPaymentSumInKopeikas(state) {
  var _findFirst2;
  var _sum = Number(getPaymentSum(state));
  var sum = (_findFirst2 = findFirst([!Number.isNaN(_sum) && _sum])) !== null && _findFirst2 !== void 0 ? _findFirst2 : 0;
  return Number.parseInt(sum * EPaymentConstant.KopeikiPerRuble, 10);
};
export var getPaymentCtn = function getPaymentCtn(state) {
  return getCommon(state).paymentData.ctn;
};
export var getUserInfo = function getUserInfo(state) {
  var _getCommon$userInfo;
  return (_getCommon$userInfo = getCommon(state).userInfo) !== null && _getCommon$userInfo !== void 0 ? _getCommon$userInfo : {};
};
export var getUserType = function getUserType(state) {
  return getUserInfo(state).type;
};
export var getUserCtn = function getUserCtn(state) {
  return getUserInfo(state).ctn;
};
export var getUserFttb = function getUserFttb(state) {
  return getUserInfo(state).fttb;
};
export var getUserNumber = function getUserNumber(state) {
  return getUserCtn(state) || getUserFttb(state);
};
export var getUserSum = function getUserSum(state) {
  return getUserInfo(state).sum || '';
};
export var getIsMobileUser = createSelector(getUserType, function (userType) {
  return userType === USER_TYPE.mobile || userType === USER_TYPE.convergent;
});
export var getShowTabsFlag = function getShowTabsFlag(state) {
  var _getCommon$showTabs, _getCommon;
  return (_getCommon$showTabs = (_getCommon = getCommon(state)) === null || _getCommon === void 0 ? void 0 : _getCommon.showTabs) !== null && _getCommon$showTabs !== void 0 ? _getCommon$showTabs : true;
};
export var getTabsVariant = function getTabsVariant(state) {
  var _getCommon2;
  return ((_getCommon2 = getCommon(state)) === null || _getCommon2 === void 0 ? void 0 : _getCommon2.tabsVariant) || 'secondary';
};
export var getActiveTabValue = createSelector(function (state) {
  return getCommon(state).activeTab;
}, getIsMobileUser, function (activeTab, isMobileUser) {
  return activeTab !== null && activeTab !== void 0 ? activeTab : isMobileUser ? MOBILE_TAB.id : FTTB_TAB.id;
});
export var getPopupContent = function getPopupContent(state) {
  return getCommon(state).popupContent;
};
export var getPaymentParams = function getPaymentParams(state) {
  return getCommon(state).paymentParams;
};
export var getAvailablePaymentMethods = function getAvailablePaymentMethods(state) {
  var _getCommon3;
  return ((_getCommon3 = getCommon(state)) === null || _getCommon3 === void 0 ? void 0 : _getCommon3.paymentMethods) || [];
};
export var getFPSCaption = function getFPSCaption(state) {
  return getCommon(state).spfCaption;
};
export var getCurrentPaymentMethodOriginal = function getCurrentPaymentMethodOriginal(state) {
  return getCommon(state).currentPaymentMethod;
};
export var getIsAuth = function getIsAuth(state) {
  var _getCommon$userInfo2;
  return !!getCommon(state).isAuth || !!((_getCommon$userInfo2 = getCommon(state).userInfo) !== null && _getCommon$userInfo2 !== void 0 && _getCommon$userInfo2.isAuth);
};
export var getIsRedesign = function getIsRedesign(state) {
  return !!getCommon(state).isRedesign;
};
export var getAvailableApplePay = createSelector(getAvailablePaymentMethods, function (methods) {
  return methods.includes(PAYMENT_METHODS_SLUGS.apple);
});
export var getAvailableGooglePay = createSelector(getAvailablePaymentMethods, function (methods) {
  return methods.includes(PAYMENT_METHODS_SLUGS.google);
});
export var getAvailableCardPay = createSelector(getAvailablePaymentMethods, function (methods) {
  return methods.includes(PAYMENT_METHODS_SLUGS.card);
});
export var getAvailableFPS = createSelector(getAvailablePaymentMethods, function (methods) {
  return methods.includes(PAYMENT_METHODS_SLUGS.fps);
});
export var getAvailableSberPay = createSelector(getAvailablePaymentMethods, function (methods) {
  return methods.includes(PAYMENT_METHODS_SLUGS.sberpay);
});
export var getPaymentsLoaded = createSelector([getAvailablePaymentMethods, getAvailableSberPay, getAvailableFPS, getAvailableCardPay, function () {
  return true;
}], function (methods, sberpay, fps, card, savedCards) {
  var payments = {
    sberpay: sberpay,
    fps: fps,
    card: card,
    savedCards: savedCards
  };
  return methods.map(function (el) {
    return !!payments[el];
  }).every(function (el) {
    return el;
  });
});